import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSanctumCsrfCookie, postApiV1AdminLogin } from '@/API/apiService';

export const AdminLoginPage: React.FC = () => {
  // フォームでは「ID」を入力していますが、バックエンドには email として送信する想定です
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  // ▼ エラーメッセージ管理用のステート
  const [errorMessage, setErrorMessage] = useState('');

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // 送信の都度、エラーメッセージをリセット
    setErrorMessage('');

    try {
      // 1. CSRFトークン取得用エンドポイントを呼び出す
      await getSanctumCsrfCookie();
      // 2. ログインAPIを呼び出し（id を email として送信）
      const loginResponse = await postApiV1AdminLogin({ email: id, password });
      // 3. ログイン成功時にユーザー情報を localStorage に保存する
      localStorage.setItem('user', JSON.stringify(loginResponse.data.user));
      // 4. 管理画面へ遷移
      navigate('/admin/property');
    } catch (error: any) {
      console.error('Login failed:', error);
      // ▼ エラー状況に応じてメッセージをセット
      if (error.response) {
        // HTTPステータスで分岐
        if (error.response.status === 401) {
          setErrorMessage('ID またはパスワードが違います。');
        } else if (error.response.status === 429) {
          setErrorMessage(
            'ログインに多数失敗しました。時間をおいて再度ログインを試みてください。'
          );
        } else {
          setErrorMessage('ログインに失敗しました。再度お試しください。');
        }
      } else {
        // ネットワークエラー、サーバー応答なし等
        setErrorMessage(
          '予期せぬエラーが発生しました。ネットワークを確認してください。'
        );
      }
    }
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-sm rounded-md bg-white p-6 shadow-md sm:p-8">
        <h1 className="mb-6 text-center text-xl font-bold sm:text-2xl">
          管理者ログイン
        </h1>
        {/* エラーメッセージ表示 (あれば) */}
        {errorMessage && (
          <div className="mb-4 rounded-md bg-red-100 p-3 text-red-700">
            {errorMessage}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* ID入力 */}
          <div>
            <label
              htmlFor="admin-id"
              className="mb-2 block text-sm font-medium text-gray-700"
            >
              ID
            </label>
            <input
              id="admin-id"
              type="text"
              placeholder="管理IDを入力"
              value={id}
              onChange={(e) => setId(e.target.value)}
              className="
                w-full 
                rounded-md border border-gray-300 
                px-3 py-2 
                text-sm 
                focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500
              "
            />
          </div>

          {/* パスワード入力 */}
          <div>
            <label
              htmlFor="admin-password"
              className="mb-2 block text-sm font-medium text-gray-700"
            >
              パスワード
            </label>
            <input
              id="admin-password"
              type="password"
              placeholder="パスワードを入力"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="
                w-full 
                rounded-md border border-gray-300 
                px-3 py-2 
                text-sm 
                focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500
              "
            />
          </div>

          {/* ログインボタン */}
          <button
            type="submit"
            className="
              w-full 
              rounded-md bg-blue-600 
              py-2 
              text-sm font-semibold text-white 
              hover:bg-blue-700 
              focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
            "
          >
            ログイン
          </button>
        </form>
      </div>
    </div>
  );
};
